<template>
  <v-container id="pagos-form" tag="section">
    <v-card elevation="12">
      <v-tabs ref="tabs" v-model="internalValue" color="white" grow slider-size="100">
        <v-tabs-slider color="gold" />
        <v-tab v-for="(item, i) in tabs" :key="i" :disabled="bloquearTabs" :ripple="false">
          {{ item }}
        </v-tab>
        <v-tab-item class="pb-1">
          <factura-tab :toggle-reset="toggleReset" :monedas="monedas" :bloquear="bloquear" @nuevosTotales="cambioTotales" />
        </v-tab-item>
        <v-tab-item class="pb-1">
          <calculo-extraordinarios :toggle-reset="toggleReset" :monedas="monedas" :bloquear="bloquear" @montoGenerado="cambioTotales" />
        </v-tab-item>
        <v-tab-item class="pb-1">
          <obligaciones-tab :toggle-reset="toggleReset" :precargado="{idJugador: idJugador, idContrato: idContrato, idObligacion: idObligacion, idSolicitud: idSolicitud}" :mode="mode" :bloquear="bloquear"
                            @nuevosTotales="cambioTotales" @mostrarGestor="MostrarGestor = $event"
          />
        </v-tab-item>
        <v-tab-item class="pb-1">
          <staff-tab :toggle-reset="toggleReset" :monedas="monedas" :bloquear="bloquear" @montoGenerado="cambioTotales" />
        </v-tab-item>
      </v-tabs>
    </v-card>
    <gestor-pagos v-if="MostrarGestor" :totales="totales" @enviarPaquete="prepararPaquete">
      <template v-slot:informacionPago>
        <informacion-pago @actualizarPago="actualizarPago" />
      </template>
    </gestor-pagos>
  </v-container>
</template>

<script>
  import FacturaTab from '../../components/FacturaTab.vue'
  import GestorPagos from '../../components/GestorPagos.vue'
  import InformacionPago from '../../components/InformacionPago.vue'
  import ObligacionesTab from '../../components/ObligacionesTab.vue'
  import CalculoExtraordinarios from '../abms/componentes/CalculoExtraordinarios'
  import StaffTab from '../../components/StaffTab'

  export default {
    name: 'FormularioPagos',
    components: {
      FacturaTab,
      GestorPagos,
      InformacionPago,
      CalculoExtraordinarios,
      ObligacionesTab,
      StaffTab,
    },
    props: {
      idObligacion: {
        type: Number,
        default: 0,
      },
      mode: {
        type: String,
        default: '',
        required: false,
      },
      idJugador: {
        type: Number,
        default: 0,
      },
      idContrato: {
        type: Number,
        default: 0,
      },
      idSolicitud: {
        type: Number,
        default: 0,
      },
    },
    data: () => ({
      tab: 0,
      tabs: ['Factura', 'Proveedor', 'Obligacion', 'Staff'],
      internalValue: 0,
      totales: {},
      monedas: [],
      bloquear: false,
      MostrarGestor: true,
      bloquearTabs: false,
      toggleReset: false,
      dataForm: {
        caso: 'Factura',
        objetoAPagar: {},
        pago: {},
      },
    }),
    computed: {

    },
    watch: {
      internalValue () {
        this.MostrarGestor = true
        this.resetFormulario()
      },
    },
    created () {
      this.getMoneda()
      if (this.mode === 'precargado') {
        this.bloquearTabs = true
        this.internalValue = 2
        // this.bloquear = true
      }
    },
    methods: {
      cambioTotales (objetoAPagar) {
        if (objetoAPagar !== null) {
          const totalesAux = {
            totalAPagar: objetoAPagar.totalAPagar,
            monedaId: objetoAPagar.monedaId,
          }
          this.totales = totalesAux
          this.totales.simboloMoneda = this.simboloMoneda(objetoAPagar.monedaId)
          this.dataForm.caso = objetoAPagar.caso
          this.dataForm.objetoAPagar = objetoAPagar.objetoPago
          this.dataForm.pago.percepciones = (objetoAPagar.percepciones !== undefined) ? objetoAPagar.percepciones : 0
          this.dataForm.pago.impuestos = (objetoAPagar.impuestos !== undefined) ? objetoAPagar.impuestos : 0
          this.dataForm.pago.monto = (objetoAPagar.monto !== undefined) ? objetoAPagar.monto : 0
          this.dataForm.pago.total = objetoAPagar.totalAPagar
          this.dataForm.pago.moneda_id = objetoAPagar.monedaId
          this.dataForm.jugador_id = (objetoAPagar.jugador_id !== undefined) ? objetoAPagar.jugador_id : null
        } else {
          const emptyObject = {
            totalAPagar: 0,
            monedaId: 0,
          }
          this.totales = emptyObject
          this.totales.simboloMoneda = '$'
          this.dataForm.objetoAPagar = {}
          this.dataForm.pago.percepciones = 0
          this.dataForm.pago.impuestos = 0
          this.dataForm.pago.monto = 0
          this.dataForm.pago.total = 0
          this.dataForm.pago.moneda_id = 1
        }
      },
      actualizarPago (datosPago) {
        this.dataForm.pago.fecha = datosPago.fecha
        this.dataForm.pago.documentacion_id = datosPago.documentacion_id
        this.dataForm.pago.notas = datosPago.notas
        this.dataForm.pago.obs = datosPago.obs
      },
      simboloMoneda (monedaId) {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === monedaId).simbolo : '$'
      },
      resetFormulario () {
        this.dataForm.caso = this.tabs[this.internalValue]
        this.totales.totalAPagar = 0
        this.totales.monedaId = 1
        this.totales.simboloMoneda = '$'
        this.dataForm.objetoAPagar = {}
        this.toggleReset = !this.toggleReset
      },
      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      prepararPaquete (datosHijo) {
        Object.assign(this.dataForm, datosHijo)
        this.enviarPaquete()
      },

      enviarPaquete: async function () {
        const mode = 'postData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/pago', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pago registrado'] })
          this.$router.push({ name: 'Pagos lista' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* const method = 'post'
        await this.$http({
          method: method,
          url: '/api/pago',
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pago registrado'] })
          this.$router.push({ name: 'Pagos lista' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        }) */
      },
    },
  }
</script>

<style lang="sass">

  .v-card
    overflow: visible

    .v-tabs-bar
      height: 56px
      padding: 0 8px

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
